import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import MessageArea from '@ui-parts/MessageArea';
import { PALETTE } from '~/assets/styles/base';
import { initialize } from '~/features/passwordReset/passwordResetSlice';
import { useAppDispatch } from '~/App/hooks';

const MessageAreaWrapper = styled.div`
  max-width: 706px;
  border: 1px solid ${PALETTE.border.frame};
  margin: 58px auto 0;
`;

const StyledForwardToInboxOutlinedIcon = styled(ForwardToInboxOutlinedIcon)`
  color: ${PALETTE.text.primary};
  font-size: 4rem;
`;

const PasswordResetSendMailCompleted = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  // isCompletedフラグを初期化
  useEffect(() => {
    dispatch(initialize());
  }, []);

  return (
    <MessageAreaWrapper>
      <MessageArea
        title={t('userMessage.passwordResetMail.title')}
        message={t('userMessage.passwordResetMail.message')}
        desc={t('userMessage.passwordResetMail.desc')}
      >
        <StyledForwardToInboxOutlinedIcon />
      </MessageArea>
    </MessageAreaWrapper>
  );
};

export default PasswordResetSendMailCompleted;
